/* Coral Keepsake story-book fitter (books whose name sits inside paragraphs, e.g. the Little Bible Storybook).
   Layout units are the 8×8 in PDF points; the 11×11 book is the same layout scaled up.
   Rules (verse books keep every line and only shrink the verse): keep the designer's line breaks while every line fits; if the name makes a line too wide,
   re-wrap that paragraph from the long line onward and move the rest of the page down;
   only if the page would run past its safe bottom, the name paragraph is set slightly smaller. */
(function(root){
'use strict';
function make(C){
  const adv=(t,s,f)=>C.metrics(t,s,f).advance;
  function wrap(words,size,font,maxW){
    const out=[];let line='';
    for(const w of words){
      if(adv(w,size,font)>maxW)return null;
      const cand=line?line+' '+w:w;
      if(line&&adv(cand,size,font)>maxW){out.push(line);line=w;}else line=cand;
    }
    if(line)out.push(line);
    return out;
  }
  function fitSingle(slot,text){
    const w=adv(text,slot.size,slot.font);let size=slot.size;
    if(w>slot.maxW)size=slot.size*slot.maxW/w;
    return {text,font:slot.font,size,x:slot.center,y:slot.y,color:slot.color,fits:Number.isFinite(size)&&size>=slot.minSize-1e-6,reduced:size<slot.size-1e-3};
  }
  // swap: optional word swap for books with a boy/girl choice (e.g. his -> her). Lines it changes are treated like name lines.
  function fitPage(page,name,swap=t=>t){
    const fill=t=>swap(t.replaceAll('[Name]',name));
    const singles=page.single.map(s=>fitSingle(s,fill(s.text)));
    for(const scale of [1,0.97,0.94,0.91,0.88]){
      let shift=0,ok=true,reduced=false,anchor=-1;const lines=[];
      for(const [pi,p] of page.paras.entries()){
        if(page.rule&&pi===page.rule.para)anchor=lines.length;
        const texts=p.lines.map(l=>fill(l.text)),has=p.lines.some(l=>l.text.includes('[Name]')||swap(l.text)!==l.text),font=p.lines[0].font;
        if(p.verse){
          // Rhyming verse: line breaks never change. If a long name makes a line too wide,
          // the whole verse is set a little smaller so all its lines stay the same size.
          const widest=Math.max(...texts.map(t=>adv(t,p.size,font)));
          const k=Math.min(1,page.maxW/widest);
          if(!Number.isFinite(k)||k<(p.minScale||0.7)){ok=false;break;}
          if(k<1)reduced=true;
          texts.forEach((t,i)=>lines.push({text:t,font:p.lines[i].font,size:p.size*k,x:p.center,y:p.lines[i].y-shift,color:p.color}));
          continue;
        }
        const size=has?p.size*scale:p.size;
        let set=texts;
        const over=texts.findIndex(t=>adv(t,size,font)>page.maxW);
        if(has&&page.rewrap){
          // Books set as flowing paragraphs (page.rewrap): the whole paragraph is re-wrapped to the text width,
          // exactly as the designer's own files do, so a short name can also pull words back up a line.
          set=wrap(texts.join(' ').split(' ').filter(Boolean),size,font,page.maxW);
          if(!set){ok=false;break;}
        }else if(has&&over>=0){
          const rest=wrap(texts.slice(over).join(' ').split(' ').filter(Boolean),size,font,page.maxW);
          if(!rest){ok=false;break;}
          set=texts.slice(0,over).concat(rest);
        }
        if(has&&size<p.size)reduced=true;
        const y0=p.lines[0].y-shift;
        set.forEach((t,i)=>{
          const src=p.lines[Math.min(i,p.lines.length-1)];
          lines.push({text:t,font:i<p.lines.length?src.font:font,size:(has?size:p.size),x:p.center,y:y0-i*p.lead,color:p.color});
        });
        shift+=(set.length-p.lines.length)*p.lead;
      }
      if(!ok)continue;
      // Text set in a card (page.centre) stays centred in it when a long name adds lines.
      if(page.centre&&shift)for(const l of lines)l.y+=shift/2;
      const low=Math.min(...lines.map(l=>l.y));
      // A decorative rule under the heading (page.rule) moves with the heading.
      const rules=page.rule&&anchor>=0?[{x0:page.rule.x0,x1:page.rule.x1,y:lines[anchor].y-page.rule.dy,w:page.rule.w,color:page.rule.color}]:[];
      if(low>=page.floor-1e-6&&(!page.ceil||Math.max(...lines.map(l=>l.y))<=page.ceil+1e-6))return {page:page.page,lines:singles.concat(lines),...(page.rule?{rules}:{}),fits:singles.every(s=>s.fits),reduced:reduced||singles.some(s=>s.reduced)};
    }
    return {page:page.page,lines:singles,fits:false,reduced:true};
  }
  /* Books with book.dedicationFit print a fixed lead-in (e.g. "With love from,") above the sign-off
     and may sit lower on the page, so they get their own safe bottom. Others use the shared engine. */
  function fitDedication(book,text,from){
    const D=book.dedicationFit||(book.closing&&book.closing.fit);if(!D)return C.fitDedication(text,from);
    if(from&&D.fromLead)from=D.fromLead+String.fromCharCode(10)+from;
    const M=C.MASTER,bottom=D.bottom||M.dedication.message.bottom;
    // Optional per-book overrides so the page matches the designer's own spacing and line length.
    const msg={...M.dedication.message,...(D.messageWidth?{width:D.messageWidth}:{}),...(D.messageLineHeight?{lineHeightFactor:D.messageLineHeight}:{}),...(D.messageColor?{color:D.messageColor}:{}),...(D.messageFont?{font:D.messageFont}:{})};
    const sign={...M.dedication.from,...(D.fromLineHeight?{lineHeightFactor:D.fromLineHeight}:{}),...(D.messageColor?{color:D.messageColor}:{}),...(D.fromFont?{font:D.fromFont}:{})};
    for(let step=0;step<=20;step++){
      const size=msg.size-(msg.size-msg.minSize)*step/20,lineHeight=size*msg.lineHeightFactor;
      const lines=C.wrapText(text,msg,size);if(!lines||(D.maxLines&&lines.length>D.maxLines))continue;
      const signSize=sign.size-(sign.size-sign.minSize)*step/20,signHeight=signSize*sign.lineHeightFactor;
      const signLines=from?C.wrapText(from,sign,signSize):[];if(!signLines)continue;
      const signY=sign.y+Math.max(0,lines.length-1)*lineHeight;
      const last=signLines.length?signY+(signLines.length-1)*signHeight+signSize:msg.y+(lines.length-1)*lineHeight+size;
      if(last<=bottom)return {fits:true,message:{...msg,size,lines,lineHeight,reduced:step>0},from:{...sign,size:signSize,lines:signLines,lineHeight:signHeight,y:signY,reduced:step>0},reduced:step>0};
    }
    return {fits:false,message:{...msg,lines:[]},from:{...sign,lines:[]},reduced:true};
  }
  /* fields = C.validateFields(...) result. Returns cover per size, dedication, and fitted pages. */
  /* opts (optional): gender ('boy'|'girl') for books with book.pronouns; closing text for books with book.closing. */
  function layout(book,fields,opts={}){
    const errors={...fields.errors},name=fields.name||'Your child',M=C.MASTER;
    const map=(book.pronouns&&book.pronouns[opts.gender])||null;
    const swap0=map?t=>t.replace(/[A-Za-z]+/g,w=>Object.prototype.hasOwnProperty.call(map,w)?map[w]:w):t=>t;
    // Books with an occasion choice (e.g. baptism or christening) swap that word all through the story.
    const occ=book.occasion?(book.occasion.words[opts.occasion]?opts.occasion:book.occasion.default):'';
    const swap=occ?t=>swap0(t.replaceAll(book.occasion.token,book.occasion.words[occ])):swap0;
    if(book.pronouns&&!book.pronouns[opts.gender]&&opts.gender!==book.pronouns.default)errors.gender='Please choose boy or girl.';
    const pages=book.pages.filter(p=>p.page!==1).map(p=>fitPage(p,name,swap));
    const covers={};
    for(const [k,c] of Object.entries(book.covers))covers[k]=fitSingle(c,c.text.replaceAll('[Name]',name));
    const dedicationName=C.fitText('For '+name,M.dedication.name);
    const dedicationLayout=fitDedication(book,fields.dedication||C.DEFAULT_DEDICATION,fields.from);
    // Optional line under "For [Name]" (e.g. "Baptism day: 12 April 2027 · St Mary’s Church").
    let dedicationSub=null;
    if(book.dedication.sub){
      const clean=v=>Array.from(String(v||''),ch=>ch.charCodeAt(0)<32||ch.charCodeAt(0)===127?' ':ch).join('').split(' ').filter(Boolean).join(' ');
      const date=clean(opts.date),place=clean(opts.place),word=occ?book.occasion.words[occ]:'';
      if(C.graphemes(date).length>40)errors.date='Please keep the date under 40 characters.';
      if(C.graphemes(place).length>60)errors.place='Please keep the church name under 60 characters.';
      if(date||place){
        const sl=book.dedication.sub,text=(word?word.charAt(0).toUpperCase()+word.slice(1)+' day: ':'')+[date,place].filter(Boolean).join(' · ');
        const w=adv(text,sl.size,sl.font),size=w>sl.maxW?sl.size*sl.maxW/w:sl.size;
        dedicationSub={text,size,fits:size>=sl.minSize-1e-6};
        if(!dedicationSub.fits&&!errors.date&&!errors.place)errors.place='The date and church line is too long to fit. Please shorten it.';
      }
    }
    if(fields.name&&!errors.name){
      const bad=pages.filter(p=>!p.fits).map(p=>p.page);
      if(bad.length||!dedicationName.fits||Object.values(covers).some(c=>!c.fits))
        errors.name='This name is too long to fit '+(bad.length?'book page '+bad.join(', '):'the cover')+' at a readable size. Please use a shorter preferred first name or contact us. Every letter is kept.';
    }
    if(!errors.dedication&&!errors.from&&!dedicationLayout.fits){errors.dedication='The dedication and sign-off won’t fit at a readable size. Please shorten the message or break up a very long word.';if(fields.from)errors.from='Please check the dedication and sign-off together.';}
    let closing='',closingLayout=null;
    if(book.closing){
      const cf=C.validateFields(fields.name,opts.closing||'',fields.binding,'');closing=cf.dedication||book.closing.default;
      if(cf.errors.dedication)errors.closing=cf.errors.dedication.replace(/dedication/g,'special message').replace(/Dedication/g,'Special message');
      closingLayout=fitDedication({closing:book.closing},closing,fields.from);
      if(!errors.closing&&!errors.from&&!closingLayout.fits)errors.closing='The special message and sign-off won’t fit at a readable size. Please shorten the message.';
    }
    return {fields,errors,gender:opts.gender||'',occasion:occ,dedicationSub,closing,closingLayout,valid:Object.keys(errors).length===0,name,possessive:C.possessiveName(name),dedication:fields.dedication||C.DEFAULT_DEDICATION,from:fields.from,covers,pages,dedicationName,dedicationLayout,
      anyNameReduced:pages.some(p=>p.reduced)||Object.values(covers).some(c=>c.reduced)||dedicationName.reduced};
  }
  /* Dedication or closing block as page lines in 8×8 points, placed exactly as the print file places them.
     D = the book's slots for that page; ded = the fitted message/sign-off; nameFit = the fitted "For [Name]" (or null).
     Books with D.extent keep the whole block centred on the designer's position as it grows or shrinks. */
  function blockLines(D,ded,nameFit,sub){
    const M=C.MASTER,out=[];
    if(nameFit&&D.name){const slot=M.dedication.name,kk=D.name.size/slot.size;out.push({text:nameFit.text,font:'BookScript',size:nameFit.size*kk,x:D.name.center,y:D.name.y-(nameFit.y-slot.y)*kk,color:D.nameColor||slot.color});}
    const kkMsg=D.message.size/M.dedication.message.size;
    for(const [key,part,slot] of [['message',ded.message,M.dedication.message],['from',ded.from,M.dedication.from]]){
      const ph=D[key],kk=ph.size/slot.size,push=D.extent?kkMsg:kk;   // centred books push the sign-off by exactly one message line per extra line
      part.lines.forEach((line,i)=>{if(line)out.push({text:line,font:part.font||slot.font,size:part.size*kk,x:ph.center,y:ph.y-((part.y-slot.y)*push+i*part.lineHeight*kk),color:part.color||slot.color});});
    }
    if(D.sub){
      // With no date or church, the message moves up into that line's space.
      const first=nameFit&&D.name?1:0;
      if(!(sub&&sub.text))out.forEach((l,i)=>{if(i>=first)l.y+=D.sub.gap;});
      if(sub&&sub.text&&sub.fits!==false)out.push({text:sub.text,font:D.sub.font,size:sub.size,x:D.sub.center,y:D.sub.y,color:D.sub.color});
    }
    if(D.extent&&out.length){const ys=out.map(l=>l.y),up=((Math.max(...ys)-Math.min(...ys))-D.extent)/2;for(const l of out)l.y+=up;}
    return out;
  }
  return {layout,fitPage,fitSingle,wrap,blockLines};
}
root.CoralStoryFit={make};
if(typeof module==='object'&&module.exports)module.exports={make};
})(typeof window!=='undefined'?window:globalThis);
